export const getMessageSummaryUpdates = (
  chat,
  message,
  latestKnownMessageId
) => {
  if (typeof message.id !== 'number') {
    return message.created_at > (chat.timestamp || 0)
      ? { timestamp: message.created_at }
      : {};
  }

  const activityAt =
    message.conversation?.last_activity_at ?? message.created_at;
  if (
    message.id < latestKnownMessageId ||
    activityAt < (chat.last_activity_at || 0)
  ) {
    return {};
  }

  return {
    timestamp: activityAt,
    ...(message.conversation
      ? { unread_count: message.conversation.unread_count }
      : {}),
  };
};
